module.exports = {
  SEGMENT_NEW: 'new',
  SEGMENT_TEST_CHANGE: 'tempChange',
  SEGMENT_DELETED: 'deleted',
  SEGMENT_PUBLISHED: 'published',
  SEGMENT_EDITED: 'edited',
  GEOCODING_TYPE_SEARCH_ADDRESS: 'geocode_address',
  SEARCH_MARKERS_LAYER_ID: 22,
  ROUTE_MARKERS_LAYER_ID: 23,
  SEGMENT_MARKERS_LAYER_ID: 40,
  CUT_POINT_MARKERS_LAYER_ID: 41,
  DISAMBIGUISATION_TOTAL_ADDRESSES: 5,
  REVERSE_GEOCODING_RIGHT_CLICK_ON_MAP: 'reverse_geocoding_right_click_on_map',
  LOCALE_FORMAT_OPTIONS: {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hc: 'h24',
  },
  LOCALE_FORMAT_OPTIONS_TEST: {
    year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'long', hour: '2-digit', minute: '2-digit', hc: 'h24'
  },
  SEGMENT_DIRECTION_POSITIVE: 1,
  SEGMENT_DIRECTION_NEGATIVE: 2,
  SEGMENT_DIRECTION_BOTH: 3,
  SEGMENT_CLOSE: 'closure',
  SEGMENT_UNBLOCK: 'unblock',
  SEGMENT_PENALIZE: 'penalize',
  SEGMENT_PRIORITIZE: 'prioritize',
  SEGMENT_TRUCK_ATTRIBUTES: 'truckattributes',
  SEGMENT_TURN_RESTRICTION: 'unblock_turn_restriction',
  SEGMENT_ORIGINAL_ATTRIBUTES: 'detourEditor_originalTruckAttributes',
  SEGMENT_MODIFIED_STREET: 'modified_street',
  SEGMENT_TYPE_TO_CATEGORY: {
    'AddedManeuver': 'Maneuver',
    'DeletedManeuver': 'Maneuver',
    'unblock_turn_restriction': 'Maneuver',
    'ExplicitlyDeletedOriginal': 'Segment',
    'ModifiedTruckattribute': 'Segment',
    'truckattributes': 'Segment',
    'penalize': 'Segment',
    'prioritize': 'Segment',
    'closure': 'Segment',
    'unblock': 'Segment',
    'ModifiedSpeed': 'Segment',
    'modified_street': 'Geometry',
    'NewStreet': 'Geometry',
    'CutPoint' : 'Geometry',
    'DividedStreet': 'Geometry',
    'DissectedStreet': 'Geometry'
  },
  SEGMENT_TYPE_HTML_VALUE_TO_ATTRIBUTE_MAPPING: {
    0: 'closure',
    1: 'unblock',
    2: 'prioritize',
    3: 'penalize',
    4: 'ExplicitlyDeletedOriginal',
    5: 'AddedManeuver',
    6: 'ModifiedSpeed'
  },
  SEGMENT_TYPE_ATTRIBUTE_TO_HTML_VALUE_MAPPING: {
    'closure': 0,
    'unblock': 1,
    'prioritize': 2,
    'penalize': 3,
    'DeletedOriginal': 4,
    'ExplicitlyDeletedOriginal': 4,
    'AddedManeuver': 5,
    'ModifiedSpeed': 6
  },
  SEGMENT_TYPE_NEW_STREET: 'NewStreet',
  SEGMENT_TYPE_DISSECTED_STREET: 'DissectedStreet',
  SEGMENT_TYPE_DIVIDED_STREET: 'DividedStreet',
  SEGMENT_TYPE_DELETED_ORIGINAL: 'DeletedOriginal',
  SEGMENT_TYPE_CUT_POINT: 'CutPoint',
  SEGMENT_TYPE_ADDED_MANEUVER: 'AddedManeuver',
  SEGMENT_TYPE_DELETED_MANEUVER: 'DeletedManeuver',
  SEGMENT_TYPE_MODIFIED_TRUCKATTRIBUTES: 'ModifiedTruckattribute',
  SEGMENT_TYPE_MODIFIED_RESTRICTIONS: 'ModifiedRestriction',
  SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL: 'ExplicitlyDeletedOriginal',
  SEGMENT_TYPE_AVOID: 'Avoid',
  SEGMENT_TYPE_PRIORITZE: 'Prioritize',
  SEGMENT_TYPE_UNBLOCK: 'Unblock',
  SEGMENT_TYPE_BLOCK: 'Block',
  SEGMENT_TYPE_MODIFIED_SPEED: 'ModifiedSpeed',
  SEGMENT_TYPE_GEOFENCE: 'Geofence',
  DRAWING_TYPE_SEGMENT: 'segment',
  DRAWING_TYPE_GEOMETRY: 'geometry',
  DRAWING_TYPE_CUT: 'cutStreet',
  DRAWING_TYPE_DEPOT: 'depot',
  PROVIDER_TOMTOM: 'tomtom',
  PROVIDER_HERE: 'here',
  PROVIDER_FWW: 'fww',
  PROVIDER_OSM: 'openstreetmap',
  PROVIDER_STORAGE_KEY: 'defaultServer',
  BASE_URL_MANAGEMENT: 'https://manager.maptrip.de/',
  BASE_URL_STAGING_MANAGEMENT: 'https://manager-staging.maptrip.de',
  DETOUR_LIMIT: 'detourLimit',
  APP_MODE_NORMAL: 'normal',
  APP_MODE_LEGACY: 'legacy',
  FWW_ACCOUNTS: ["dirk.schucka@stadt.wuppertal.de", "Berufsfeuerwehr Wuppertal"],
  MAPTYPE_WUPPERTAL: 'Here_Wuppertal_2016_06',
  PENALIZE_PRIORITIZE_BREAKPOINT: 1,
  PRIORITY_ATTRIBUTE_NAME: 'priority',
  PENALIZE_DEFAULT_VALUE: 0.1,
  PRIORITIZE_DEFAULT_VALUE: 10,
  EMERGENCY_RADIUS_DEFAULT: 1000,
  DEFAULT_EMERGENCY_RADIUS_SETTINGS: {
   'closure': false,
   'AddedManeuver': false,
   'penalize': true,
   'prioritize': true,
   'unblock': true,
   'truckattributes': true
  },
  DEFAULT_VALIDITY: {
    'closure': 9,
    'penalize': 5,
    'prioritize': 5,
    'unblock': 5,
    'truckattributes': 5,
    'closure-both': 10,
    'AddedManeuver': 9
  },
  LIMITED_SEGMENTS: [
    'CutPoint',
    'ExplicitlyDeletedOriginal',
    'NewStreet',
    'ModifiedTruckattribute',
    'AddedManeuver',
    'Block',
    'Avoid',
    'Prioritize',
    'Unblock',
    'DeletedManeuver',
  ],
  TRUCK_ATTRIBUTE_TYPE_TO_VALUE_MAPPING: {
    'width': 0,
    'height': 1,
    'length': 2,
    'weight': 3,
    'axleWeight': 4,
    'hazardLoad': 33,
    'explosiveLoad': 34,
    'harmfulLoad': 35,
    'hazmatAllClasses': 36,
    'A': 37,
    'B': 38,
    'C': 39,
    'D': 40,
    'E': 41,
    'axleCount': 50
  },
  TRUCK_ATTRIBUTE_VALUE_TO_TYPE_MAPPING: {
    0: 'width',
    1: 'height',
    2: 'length',
    3: 'weight',
    4: 'axleWeight',
    33: 'hazardLoad',
    34: 'explosiveLoad',
    35: 'harmfulLoad',
    36: 'hazmatAllClasses',
    37: 'A',
    38: 'B',
    39: 'C',
    40: 'D',
    41: 'E',
    50: 'axleCount',
  },
  MAP_TYPE_TO_TYPE_MAPPING: {
    0: 'AAA',
    1: 'BBB',
    2: 'FCB',
    3: 'SSS'
  },
  TRUCK_ATTRIBUTE_TYPE_TO_TRANSLATION: {
    'width': 'editor.truck-attributes.width',
    'height': 'editor.truck-attributes.height',
    'length': 'editor.truck-attributes.length',
    'weight': 'editor.truck-attributes.weight',
    'axleWeight': 'editor.truck-attributes.weight-per-axle',
    'hazardLoad': 'editor.truck-attributes.hazardous-load',
    'explosiveLoad': 'editor.truck-attributes.explosive-load',
    'harmfulLoad': 'editor.truck-attributes.harmful-to-water',
    'hazmatAllClasses': 'editor.truck-attributes.hazmat-all-classes',
    'A': 'editor.truck-attributes.tunnel-category-a',
    'B': 'editor.truck-attributes.tunnel-category-b',
    'C': 'editor.truck-attributes.tunnel-category-c',
    'D': 'editor.truck-attributes.tunnel-category-d',
    'E': 'editor.truck-attributes.tunnel-category-e',
    'axleCount': 'editor.truck-attributes.axles'
  },
  FILE_CHECK_ERROR_CODE: {
    0: "Unknown",
    1: "Already checked",
    2: "Olr OK",
    3: "Olr decoding failure",
    4: "Olr geometry difference at start or end point",
    5: "Olr geometry inner difference",
    6: "Maneuver difference",
    7: "Geometry OK",
    8: "Cannot find original street",
    9: "Not connected to the street network"
  },
  TRUCK_ATTRIBUTE_UNIT_CONVERSION_VALUES: {
    'cm': 100,
    '100 kg': 10
  },
  WMTS_MAP_USER: [
    "traveco transporte ag"
  ],
  INVALID_CHARACTERS: [
    '\\',
    '<',
    '>',
    '{',
    '}',
  ],
};
